import { AuthorizeContext } from './AuthorizeContext';

export function withAuthorizeContext(Component: any) {
  return function propsWrapper(props?: any) {
    return (
      <AuthorizeContext.Consumer>
        {(value) => <Component {...props} {...value} />}
      </AuthorizeContext.Consumer>
    );
  };
}
